import React, { type FC, useEffect, useState } from "react";
import { reportError } from "@app/services/error-reporter";
import "./Version.scss";

interface PatchNotes {
    version: string;
    date: string;
    changes: string[];
}

interface CurrentReleaseNotes extends PatchNotes {
    buildId: string;
    commit: string;
    profile: string;
}

interface ReleaseInfo {
    current: CurrentReleaseNotes;
    history: PatchNotes[];
}

const Version: FC = () => {
    const [releaseInfo, setReleaseInfo] = useState<ReleaseInfo>();

    useEffect(() => {
        fetch(`${import.meta.env.BASE_URL}release.json`)
            .then(async (response) => {
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                const data: ReleaseInfo = await response.json();
                return data;
            })
            .then((data) => {
                setReleaseInfo(data);
            })
            .catch(() => {
                reportError(new Error("Ошибка при чтении информации о сборке. Обратитесь к системному администратору."), {
                    from: "Version.loadReleaseInfo",
                });
            });
    }, []);

    if (releaseInfo === undefined) return null;

    const { current, history } = releaseInfo;

    return (
        <div className="system_version_info">
            <section className="current_version">
                <strong>OMP Mobile {current.version}</strong>
                <dl className="build_metadata">
                    <div>
                        <dt>Сборка</dt>
                        <dd>{current.buildId}</dd>
                    </div>
                    <div>
                        <dt>Дата</dt>
                        <dd>{current.date}</dd>
                    </div>
                    <div>
                        <dt>Код</dt>
                        <dd>{current.commit}</dd>
                    </div>
                    <div>
                        <dt>Профиль</dt>
                        <dd>{current.profile}</dd>
                    </div>
                </dl>
            </section>
            <div className="versions custom_scrollbar">
                {history.map((item) => (
                    <section key={`${item.version}-${item.date}`} className="version_item">
                        <b>
                            Версия {item.version} от {item.date}
                        </b>
                        <div className="changes_container">
                            {item.changes.length === 0
                                ? "Описание изменений не сохранилось."
                                : item.changes.map((change) => <div key={change}>• {change}</div>)}
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default Version;
